// extracted by mini-css-extract-plugin
export var addButton = "_qb-0";
export var border = "_qb-8";
export var check = "_qb-h";
export var danger = "_qb-6";
export var dropdownContainer = "_qb-1";
export var editModalBody = "_qb-j";
export var footerContainer = "_qb-i";
export var fullWidth = "_qb-a";
export var hide = "_qb-9";
export var icon = "_qb-3";
export var input = "_qb-7";
export var inputFlex = "_qb-b";
export var inputWrapper = "_qb-c";
export var manualFocus = "_qb-5";
export var optionButton = "_qb-4";
export var pillWrapper = "_qb-e";
export var pointer = "_qb-2";
export var showOverflow = "_qb-f";
export var tagsFlex = "_qb-d";
export var xButton = "_qb-g";